// extracted by mini-css-extract-plugin
export default {"puzzle":"SolvePuzzle_puzzle__7xuZp"};